export const helmet = {
    title: "Publisher Portal",
    metaTags: [
        { name: "description", content: "A dapp which assists the user to publish his service" },
    ],
};
